(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbd-topic-carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-related-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    const track = carousel.querySelector('[data-related-track]');
    const previous = carousel.querySelector('[data-related-previous]');
    const next = carousel.querySelector('[data-related-next]');

    if (!track || !previous || !next) return;

    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    const move = (direction) => {
      track.scrollBy({
        left: direction * Math.max(track.clientWidth * 0.82, 280),
        behavior: 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    new ResizeObserver(updateControls).observe(track);
    updateControls();
  });
  } catch(e) { console.error(e); }
})();

})();
